import { Component, OnInit, Input, OnDestroy, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { PrerollCreativeComponent } from '../preroll-creative/preroll-creative.component';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import * as jQuery from 'jquery';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { CONSTANTS, EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { VideoCompletionPercentage } from '../creative-detail-v2/creative-detail.interface';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';

@Component({
	selector: 'app-preroll-creative-v3',
	templateUrl: './preroll-creative-v3.component.html',
	styleUrls: ['./preroll-creative-v3.component.css']
})
export class PrerollCreativeV3Component extends PrerollCreativeComponent implements OnInit, AfterViewInit, OnDestroy {
	public showPercentageRadius = true;
	public carouselOne: NguCarouselConfig;
	public overallCompletionData: VideoCompletionPercentage;
	public widgetDataSubscription;
	public isAudioCreative;
	public downloadCSVColumns: any;
	public isRadio: boolean;
	@ViewChild('carousel') carousel: NguCarousel<any>;
	@Input() downloadconfig: string;
	public downloadConfiguration: DownloadConfig;
	@Input() downloadcsvcolumns: any;
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef
	) {
		super(analyticsService, analyticsDataModel, cdr);
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: true,
			touch: true,
			velocity: 0.2,
			point: {
				visible: true
				// hideOnSingleSlide: true
			}
		};
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.hasData = false;
			this.showLoad = true;
			this.requestData();
		});
	}

	ngOnInit() {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.primaryColor = this.colorPalette.primaryColor;
		this.defaultColor = 'white';
		this.showLoad = true;
		this.hasData = false;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.isRadio = this.analyticsDataModel.getCurrentPath() === PATHS.AUDIO;
		this.youtubeViewsPermission = this.analyticsDataModel.checkComponentForPermission(this.youtubeViewsPermissionCheck);
		this.isPreroll = this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
		this.requestData();
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
		this.cdr.detectChanges();
	}

	requestData() {
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			if (res.success && res.data.length > 0) {
				this.hasData = true;
				this.setData(res.data);
			} else {
				this.hasData = false;
			}
		});
	}

	setData(response) {
		this.displayData = response;
		this.getDisplayIndex = this.displayData.length - 1;
		this.carouselItemsLength = this.displayData.length;
		this.setSlide();
		this.overallCompletionData = this.setOverallCompletionRates(this.displayData);
		setTimeout(() => {
			this.setDisplayIndexContent(0);
			this.isAudioCreative = this.setDisplayProperties.audioURL !== '';
			if (this.isAudioCreative && this.isRadio) {
				jQuery('.portlet-subheader-wrapper').attr('style', function (i, s) {
					return (s || '') + 'position: relative !important;';
				});
				jQuery('.portlet-subheader-wrapper h5').attr('style', function (i, s) {
					return (s || '') + 'position: absolute !important; top: 2px';
				});
				jQuery('.preroll_creative_icon .datatable_download_icon.creative_download_icon').attr('style', function (i, s) {
					return (s || '') + 'top: -5px !important; z-index: 10;';
				});
				setTimeout(() => {
					this.controlsOptions(this.primaryColor, this.defaultColor);
					if (jQuery('#preRollvideo')[0]) {
						jQuery('#preRollvideo')[0].autoplay = this.setDisplayProperties.mp4 != null;
					}
				});
			} else {
				this.controlsOptions(this.primaryColor, this.defaultColor);
			}
		});
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	onmoveFn(event) {
		this.setDisplayIndexContent(event.currentSlide);
		jQuery('.creative_mask').show();
		jQuery('#preRollvideo')[0].currentTime = 0;
		jQuery('#preRollvideo')[0].play();
	}

	getPercentageClass(percentage) {
		if (this.setDisplayProperties.mp4 != null && !this.isRadio) {
			return `p${Math.floor(percentage)}`;
		} else if (this.isAudioCreative && this.isRadio) {
			return `noHover p${Math.floor(percentage)}`;
		}
	}

	getPercentage(percentage) {
		return { width: `${Math.floor(percentage)}%` };
	}

	circleVideoClickEvent(typeOfPercent) {
		if (this.setDisplayProperties.mp4 != null || this.setDisplayProperties.audioURL !== '') {
			jQuery('.creative_mask').show();
			jQuery('.creative_text_mask').css('opacity', 0.5);
			const gettheVideoTotalDuration = this.videoplayer.nativeElement.duration;
			const gettheEqualDuration = parseFloat(gettheVideoTotalDuration) / 4;
			const splitURL =
				this.setDisplayProperties.mp4 != null
					? this.setDisplayProperties.mp4.split('#')
					: this.setDisplayProperties.audioURL.split('#');
			this.setDisplayProperties.mp4 = splitURL[0];
			const urlName = this.setDisplayProperties.mp4;
			const setStartEndTime = '';
			let getStartTime;
			let getEndTime;
			let calcDuration;
			if (typeOfPercent === 0) {
				jQuery('#creative_mask_0').hide();
				jQuery('#percent0').css('opacity', 1);
				jQuery('#preRollvideo')[0].currentTime = 0;
				jQuery('#preRollvideo')[0].play();
				getStartTime = 0;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = gettheEqualDuration - getStartTime;
				calcDuration = calcDuration * 1000;
			} else if (typeOfPercent === 25) {
				jQuery('#creative_mask_25, #creative_mask_0').hide();
				jQuery('#percent0, #percent25').css('opacity', 1);
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = 0;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = gettheEqualDuration - getStartTime;
				calcDuration = calcDuration * 1000;
			} else if (typeOfPercent === 50) {
				jQuery('#creative_mask_50, #creative_mask_25, #creative_mask_0').hide();
				jQuery('#percent0, #percent25, #percent50').css('opacity', 1);
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration + gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = gettheEqualDuration;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = getEndTime - getStartTime;
				calcDuration = calcDuration * 1000;
			} else if (typeOfPercent === 75) {
				jQuery('#creative_mask_75, #creative_mask_0, #creative_mask_25, #creative_mask_50').hide();
				jQuery('#percent0, #percent25, #percent50, #percent75').css('opacity', 1);
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = gettheEqualDuration + gettheEqualDuration;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = getEndTime - getStartTime;
				calcDuration = calcDuration * 1000;
			} else if (typeOfPercent === 100) {
				jQuery('.creative_mask').hide();
				jQuery('.creative_text_mask').css('opacity', 1);
				const getCurrentTime = jQuery('#preRollvideo')[0].currentTime;
				const totDuration = jQuery('#preRollvideo')[0].duration;
				if (getCurrentTime < totDuration) {
					jQuery('#preRollvideo')[0].currentTime = gettheVideoTotalDuration - 1;
					jQuery('#preRollvideo')[0].play();
					getStartTime = gettheEqualDuration + gettheEqualDuration;
					getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
					calcDuration = getEndTime - getStartTime;
					calcDuration = calcDuration * 1000;
				}
				if (getCurrentTime >= totDuration) {
					jQuery('#preRollvideo')[0].currentTime = 0;
					jQuery('#preRollvideo')[0].play();
					getStartTime = gettheEqualDuration + gettheEqualDuration;
					getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
					calcDuration = getEndTime - getStartTime;
					calcDuration = calcDuration * 1000;
				}
			}
		}
	}

	controlsOptions(primaryColor?, defaultColor?) {
		const isAudioCreative = this.setDisplayProperties.audioURL !== '';
		if (jQuery('#preRollvideo')[0]) {
			jQuery('#preRollvideo')[0].autoplay = this.setDisplayProperties.mp4 != null;
		}
		const media = document.getElementById('preRollvideo');
		let gettheVideoTotalDuration;
		let checkfor0Percentage;
		let checkfor25Percentage;
		let checkfor50Percentage;
		let checkfor75Percentage;
		let checkfor100Percentage;
		const isPlaying = function (e) {
			gettheVideoTotalDuration = jQuery('#preRollvideo')[0].duration;
			checkfor0Percentage = 0 / 4;
			checkfor25Percentage = gettheVideoTotalDuration / 4;
			checkfor50Percentage = parseFloat(checkfor25Percentage) * 2;
			checkfor75Percentage = parseFloat(checkfor25Percentage) * 3;
			checkfor100Percentage = parseFloat(checkfor25Percentage) * 4;
			jQuery('#pauseBtn').show();
			jQuery('#playBtn').hide();
		};
		const onPause = function (e) {
			jQuery('#pauseBtn').hide();
			jQuery('#playBtn').show();
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime === gettheVideoTotalDuration) {
				jQuery('#percent0').css('opacity', 1);
				jQuery('#percent25').css('opacity', 1);
				jQuery('#percent50').css('opacity', 1);
				jQuery('#percent75').css('opacity', 1);
				jQuery('#percent100').css('opacity', 1);
			}
		};
		const onTimeUpdate = function (e) {
			if (isAudioCreative) {
				jQuery('.creative_mask').show();
			}
			if (
				jQuery('#preRollvideo')[0] &&
				jQuery('#preRollvideo')[0].currentTime >= checkfor25Percentage &&
				jQuery('#preRollvideo')[0] &&
				jQuery('#preRollvideo')[0].currentTime < checkfor50Percentage
			) {
				jQuery('#creative_mask_25, #creative_mask_0').hide();
				jQuery('#percent0, #percent25').css('opacity', 1);
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor25Percentage) {
				jQuery('#creative_mask_0').hide();
				jQuery('#percent0').css('opacity', 1);
			}
			if (
				jQuery('#preRollvideo')[0] &&
				jQuery('#preRollvideo')[0].currentTime >= checkfor50Percentage &&
				jQuery('#preRollvideo')[0] &&
				jQuery('#preRollvideo')[0].currentTime < checkfor75Percentage
			) {
				jQuery('#creative_mask_25, #creative_mask_0, #creative_mask_50').hide();
				jQuery('#percent0, #percent25, #percent50').css('opacity', 1);
			}
			if (
				jQuery('#preRollvideo')[0] &&
				jQuery('#preRollvideo')[0].currentTime >= checkfor75Percentage &&
				jQuery('#preRollvideo')[0] &&
				jQuery('#preRollvideo')[0].currentTime < checkfor100Percentage
			) {
				jQuery('#creative_mask_25, #creative_mask_0, #creative_mask_50, #creative_mask_75').hide();
				jQuery('#percent0, #percent25, #percent50, #percent75').css('opacity', 1);
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor100Percentage) {
				jQuery('#creative_mask_25, #creative_mask_0, #creative_mask_50, #creative_mask_75, #creative_mask_100').hide();
				jQuery('#percent0, #percent25, #percent50, #percent75, #percent100').css('opacity', 1);
			}
		};
		if (media) {
			media.addEventListener('playing', isPlaying, false);
			media.addEventListener('pause', onPause, false);
			media.addEventListener('timeupdate', onTimeUpdate, false);
		}
	}
	playclickEvent() {
		jQuery('#preRollvideo')[0].play();
		if (jQuery('#preRollvideo')[0].currentTime == 0) {
			jQuery('#creative_mask_25, #creative_mask_50, #creative_mask_75, #creative_mask_100').show();
		}
	}
	downloadCSV(e) {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}
	setOverallCompletionRates(prerollCreatives: any[]) {
		const videoCompletionPercentage: VideoCompletionPercentage = <VideoCompletionPercentage>{};
		for (const prerollCreative of prerollCreatives) {
			videoCompletionPercentage.started = 100;
			videoCompletionPercentage.startedValue = videoCompletionPercentage.startedValue
				? videoCompletionPercentage.startedValue + parseInt(prerollCreative['impressions'])
				: parseInt(prerollCreative['impressions']);
			videoCompletionPercentage.quarterValue = videoCompletionPercentage.quarterValue
				? videoCompletionPercentage.quarterValue + parseInt(prerollCreative['25_percent_value'])
				: parseInt(prerollCreative['25_percent_value']);
			videoCompletionPercentage.halfValue = videoCompletionPercentage.halfValue
				? videoCompletionPercentage.halfValue + parseInt(prerollCreative['50_percent_value'])
				: parseInt(prerollCreative['50_percent_value']);
			videoCompletionPercentage.threeQuartersValue = videoCompletionPercentage.threeQuartersValue
				? videoCompletionPercentage.threeQuartersValue + parseInt(prerollCreative['75_percent_value'])
				: parseInt(prerollCreative['75_percent_value']);
			videoCompletionPercentage.completionValue = videoCompletionPercentage.completionValue
				? videoCompletionPercentage.completionValue + parseInt(prerollCreative['100_percent_value'])
				: parseInt(prerollCreative['100_percent_value']);
		}
		videoCompletionPercentage.quarter = (
			(100 * videoCompletionPercentage.quarterValue) /
			videoCompletionPercentage.startedValue
		).toFixed(2);
		videoCompletionPercentage.half = (
			(100 * videoCompletionPercentage.halfValue) /
			videoCompletionPercentage.startedValue
		).toFixed(2);
		videoCompletionPercentage.threeQuarters = (
			(100 * videoCompletionPercentage.threeQuartersValue) /
			videoCompletionPercentage.startedValue
		).toFixed(2);
		videoCompletionPercentage.completed = (
			(100 * videoCompletionPercentage.completionValue) /
			videoCompletionPercentage.startedValue
		).toFixed(2);

		return videoCompletionPercentage;
	}
}
